import React, { lazy, Suspense } from 'react'
import PropTypes from 'prop-types'
import { Route, withRouter, Switch } from 'react-router'
import yn from 'yn'
import FourOFour from 'App/FourOFour'

const ItauCardLanding = lazy(() =>
  import('features/Benefits/Landing/ItauCardLanding')
)
const ItauCardListing = lazy(() =>
  import('features/Benefits/Listing/ItauCardListing')
)

const BenefitsRouter = ({ match: { url } }) =>
  yn(process.env.REACT_APP_ALLOW_BENEFITS) ? (
    <Suspense fallback={<div />}>
      <Switch>
        <Route path={`${url}/landing`} component={ItauCardLanding} />
        <Route path={`${url}/listing`} component={ItauCardListing} />
        <Route component={FourOFour} />
      </Switch>
    </Suspense>
  ) : (
    <Route component={FourOFour} />
  )

BenefitsRouter.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  })
}

export default withRouter(BenefitsRouter)



// WEBPACK FOOTER //
// ./src/features/Benefits/BenefitsRouter.js